// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalBackdrop_backdrop__l6Glp"};